import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { DATE_NAME_MAX_LENGTH } from 'const/limits'
import {
  FormControl,
  FormGroup,
  HelpBlock
} from 'react-bootstrap'
import KanBoIcon from 'components/KanBoIcon'
import CardDateAction from 'components/CardActions/Date'
import {
  Menu,
  MenuItem
} from 'components/Menu'
import classes from './AddDate.module.scss'

const Dates = {
  START: 1,
  DUE: 2,
  CUSTOM: 3,
  PERSONAL: 4
}

export class AddDate extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,

    calendarDate: PropTypes.number,

    requestChangeStartDate: PropTypes.func.isRequired,
    requestChangeDueDate: PropTypes.func.isRequired,
    requestAddCustomDate: PropTypes.func.isRequired,
    requestAddPersonalDate: PropTypes.func.isRequired,

    id: PropTypes.number.isRequired,
    onDateChange: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      addingDate: null,
      dateName: '',
      dateNameError: false
    }

    this.handleStartDateClick = this.handleStartDateClick.bind(this)
    this.handleDueDateClick = this.handleDueDateClick.bind(this)
    this.handleCustomDateClick = this.handleCustomDateClick.bind(this)
    this.handlePersonalDateClick = this.handlePersonalDateClick.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleInputFocus = this.handleInputFocus.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  handleStartDateClick () {
    this.setState({
      addingDate: Dates.START
    })
  }

  handleDueDateClick () {
    this.setState({
      addingDate: Dates.DUE
    })
  }

  handleCustomDateClick () {
    this.setState({
      addingDate: Dates.CUSTOM,
      dateName: this.props.intl.formatMessage({ id: 'CARD_DATE' })
    })
  }

  handlePersonalDateClick () {
    this.setState({
      addingDate: Dates.PERSONAL,
      dateName: this.props.intl.formatMessage({ id: 'CARD_DATE_PERSONAL' })
    })
  }

  handleDateChange (date) {
    const { id } = this.props
    const { dateName, dateNameError } = this.state

    if (dateNameError) return

    switch (this.state.addingDate) {
      case Dates.START:
        this.props.requestChangeStartDate({
          cardId: id,
          startDate: date
        })
        break
      case Dates.DUE:
        this.props.requestChangeDueDate({
          cardId: id,
          dueDate: date
        })
        break
      case Dates.CUSTOM:
        this.props.requestAddCustomDate({
          cardId: id,
          timestamp: date,
          name: dateName
        })
        break
      case Dates.PERSONAL:
        this.props.requestAddPersonalDate({
          cardId: id,
          timestamp: date,
          name: dateName,
        })
        break
      default:
        break
    }

    this.props.onDateChange()
  }

  handleInputFocus (event) {
    const tempValue = event.target.value
    event.target.value = ''
    event.target.value = tempValue
  }

  handleInputChange (event) {
    const dateName = event.target.value

    let dateNameError = false
    if (!dateName) {
      dateNameError = this.props.intl.formatMessage({ id: 'DATE_NAME_EMPTY' })
    } else if (dateName.length > DATE_NAME_MAX_LENGTH) {
      dateNameError = this.props.intl.formatMessage({ id: 'DATE_NAME_TOO_LONG' }, { limit: DATE_NAME_MAX_LENGTH })
    }

    this.setState({
      dateName,
      dateNameError
    })
  }

  render () {
    const {
      addingDate,
      dateName,
      dateNameError
    } = this.state

    const {
      calendarDate
    } = this.props

    if (!addingDate) {
      return (
        <Menu style={{ width: '100%' }}>
          <MenuItem
            icon={<KanBoIcon name='kanbo-16-start-date' />}
            onClick={this.handleStartDateClick}
          >
            <FormattedMessage id='CARD_START_DATE' />
          </MenuItem>
          <MenuItem
            icon={<KanBoIcon name='kanbo-16-due-date' />}
            onClick={this.handleDueDateClick}
          >
            <FormattedMessage id='CARD_DUE_DATE' />
          </MenuItem>
          <MenuItem
            icon={<KanBoIcon name='kanbo-16-card-date' />}
            onClick={this.handleCustomDateClick}
          >
            <FormattedMessage id='CARD_DATE' />
          </MenuItem>
          <MenuItem
            icon={<KanBoIcon name='kanbo-16-personal-reminder' />}
            onClick={this.handlePersonalDateClick}
          >
            <FormattedMessage id='CARD_DATE_PERSONAL' />
          </MenuItem>
        </Menu>
      )
    } else {
      return (
        <div className={classes.addDate}>
          {(addingDate === Dates.CUSTOM || addingDate === Dates.PERSONAL) &&
            <FormGroup
              validationState={dateNameError ? 'error' : null}
            >
              <FormControl
                type='text'
                autoFocus
                value={dateName}
                onFocus={this.handleInputFocus}
                onChange={this.handleInputChange}
              />
              {dateNameError && <HelpBlock>{dateNameError}</HelpBlock>}
            </FormGroup>
          }
          <CardDateAction
            date={(addingDate !== Dates.PERSONAL && addingDate !== Dates.CUSTOM) ? calendarDate : null}
            onDateChange={this.handleDateChange}
          />
        </div>
      )
    }
  }
}

export default injectIntl(AddDate)
